import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin: ${rem(15)} 0 ${rem(45)} 0;
    padding: ${rem(30)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        display: flex;
        flex-direction: column;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;

export const EmptyMessage = styled.span`
    display: block;
    text-align: center;
    padding-bottom: ${rem(40)};
    color: ${({ theme }) => theme.colors.grey};
    line-height: ${rem(30)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;



export const ShowMore = styled.div`
    display: flex;
    justify-content: center;
`;

